import { rankList } from "@/mocks/home";

const heroTags = ["暑期档口碑之争", "综艺阵容官宣", "爆款微短剧", "黑马新秀逆转"];

export default function Hero() {
  const go = (id: string) => document.getElementById(id)?.scrollIntoView({ behavior: "smooth", block: "start" });

  return (
    <section className="relative overflow-hidden bg-background-50">
      <div className="pointer-events-none absolute -right-24 top-0 h-80 w-80 rounded-full bg-secondary-100/70 blur-3xl"></div>
      <div className="pointer-events-none absolute -left-24 bottom-0 h-72 w-72 rounded-full bg-accent-100/60 blur-3xl"></div>

      <div className="relative mx-auto max-w-7xl px-4 py-10 md:px-6 md:py-16">
        <div className="grid items-center gap-8 lg:grid-cols-12 lg:gap-10">
          {/* 左：文案 */}
          <div className="lg:col-span-6">
            <div className="inline-flex items-center gap-2 rounded-full bg-accent-100 px-3 py-1 text-xs font-bold text-accent-800">
              <i className="ri-fire-fill text-sm text-primary-600"></i>
              热门大瓜 · 一网打尽
            </div>
            <h1 className="mt-5 font-heading text-4xl font-bold leading-tight tracking-tight text-foreground-950 md:text-5xl lg:text-[3.4rem]">
              全网热搜都在聊什么？
              <br />
              <span className="text-primary-600">吃瓜17</span> 带你一次看懂
            </h1>
            <p className="mt-5 max-w-xl text-base leading-relaxed text-foreground-700 md:text-lg">
              聚焦热点焦点排行，实时盘点热议大瓜与焦点话题。从娱乐影视到社会百态，聚合公开信息、还原来龙去脉，理性围观不迷路，新鲜热度随时掌握。
            </p>

            <div className="mt-6 flex flex-wrap gap-2">
              {heroTags.map((t) => (
                <button
                  key={t}
                  type="button"
                  onClick={() => go("buzz")}
                  className="flex items-center gap-1 rounded-full border border-background-300 bg-background-100 px-3 py-1.5 text-sm text-foreground-700 transition-colors hover:border-primary-300 hover:bg-primary-50 hover:text-primary-800"
                >
                  <i className="ri-hashtag text-secondary-600"></i>
                  {t}
                </button>
              ))}
            </div>

            <div className="mt-7 flex flex-wrap items-center gap-3">
              <button
                type="button"
                onClick={() => go("rank")}
                className="flex items-center gap-2 rounded-md bg-primary-500 px-5 py-2.5 text-sm font-bold whitespace-nowrap text-background-50 transition-colors hover:bg-primary-600"
              >
                查看实时热榜
                <i className="ri-arrow-right-line"></i>
              </button>
              <button
                type="button"
                onClick={() => go("deep")}
                className="flex items-center gap-2 rounded-md border border-accent-300 bg-accent-50 px-5 py-2.5 text-sm font-bold whitespace-nowrap text-accent-800 transition-colors hover:bg-accent-100"
              >
                <i className="ri-book-open-line"></i>
                阅读深度盘点
              </button>
            </div>
          </div>

          {/* 右：主图 */}
          <div className="lg:col-span-6">
            <div className="relative">
              <div className="overflow-hidden rounded-2xl border border-background-200 bg-background-100">
                <img
                  src="https://readdy.ai/api/search-image?query=Warm%20abstract%20editorial%20magazine%20cover%20art%20with%20large%20glossy%20watermelon%20slice%20shapes%20in%20coral%20red%20and%20deep%20melon%20green%20floating%20over%20cream%20canvas%2C%20soft%20gradient%20orbs%2C%20subtle%20paper%20grain%2C%20modern%20fashion%20illustration%20style%2C%20soft%20studio%20lighting%2C%20high%20detail%2C%20no%20text&width=1040&height=760&seq=hero-main&orientation=landscape"
                  alt="吃瓜17 全网热点焦点排行专题封面"
                  className="h-[300px] w-full object-cover md:h-[400px]"
                />
              </div>

              <div className="absolute left-4 top-4 flex items-center gap-1.5 rounded-full bg-accent-950/90 px-3 py-1.5 text-xs font-bold text-background-50">
                <span className="relative flex h-2 w-2">
                  <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-primary-400"></span>
                  <span className="relative inline-flex h-2 w-2 rounded-full bg-primary-400"></span>
                </span>
                正在发酵 · 实时更新
              </div>

              <div className="absolute bottom-4 left-4 right-4 rounded-xl border border-background-100/40 bg-background-50/90 p-3 backdrop-blur-sm">
                <p className="text-xs font-bold text-primary-700">今日头条热榜 TOP 1</p>
                <p className="mt-1 line-clamp-2 text-sm font-semibold text-foreground-950">{rankList[0].title}</p>
                <div className="mt-2 flex items-center gap-3">
                  <span className="inline-flex items-center gap-1 rounded-md bg-primary-500 px-2 py-0.5 text-xs font-bold text-background-50">
                    <i className="ri-fire-fill"></i>
                    热度 {rankList[0].heat}
                  </span>
                  <span className="text-xs text-foreground-600">{rankList[0].tag}</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* 快捷入口 */}
        <div className="mt-10 grid grid-cols-2 gap-3 sm:grid-cols-4">
          {[
            { icon: "ri-fire-line", label: "实时热榜", target: "rank", sub: "Top10 动态排行" },
            { icon: "ri-folder-2-line", label: "焦点专区", target: "focus", sub: "分类话题聚合" },
            { icon: "ri-sparkling-line", label: "大瓜现场", target: "buzz", sub: "热议事件盘点" },
            { icon: "ri-newspaper-line", label: "深度讨论", target: "deep", sub: "专题长文解读" },
          ].map((c, i) => (
            <button
              key={c.label}
              type="button"
              onClick={() => go(c.target)}
              className="group flex items-center gap-3 rounded-xl border border-background-200 bg-background-100/70 p-3.5 text-left transition-colors hover:border-accent-300 hover:bg-background-50 md:p-4"
            >
              <span className={`flex h-11 w-11 shrink-0 items-center justify-center rounded-lg text-xl text-background-50 md:h-12 md:w-12 ${i % 2 === 0 ? "bg-accent-500" : "bg-secondary-500"}`}>
                <i className={c.icon}></i>
              </span>
              <span className="min-w-0">
                <span className="block text-sm font-bold whitespace-nowrap text-foreground-950 md:text-base">{c.label}</span>
                <span className="block truncate text-xs text-foreground-600">{c.sub}</span>
              </span>
              <i className="ri-arrow-right-line ml-auto shrink-0 text-secondary-500 transition-transform group-hover:translate-x-0.5"></i>
            </button>
          ))}
        </div>
      </div>
    </section>
  );
}